/**
 * DateRangePicker Component
 * Pre-configured RangePicker with common presets
 * Consistent date selection across the app
 */

import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

/**
 * Common date range presets
 */
const rangePresets = [
  {
    label: 'Today',
    value: [dayjs().startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 7 Days',
    value: [dayjs().subtract(7, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 30 Days',
    value: [dayjs().subtract(30, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 90 Days',
    value: [dayjs().subtract(90, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'This Month',
    value: [dayjs().startOf('month'), dayjs().endOf('month')],
  },
  {
    label: 'Last Month',
    value: [
      dayjs().subtract(1, 'month').startOf('month'),
      dayjs().subtract(1, 'month').endOf('month'),
    ],
  },
  {
    label: 'This Year',
    value: [dayjs().startOf('year'), dayjs().endOf('year')],
  },
];

/**
 * DateRangePicker Component
 *
 * @param {Array} value - Selected date range [start, end]
 * @param {function} onChange - Change handler
 * @param {Array} presets - Custom presets (default: common presets)
 * @param {string} format - Date format (default: YYYY-MM-DD)
 * @param {boolean} showTime - Show time picker (default: false)
 * @param {string} placeholder - Placeholder text array
 * @param {Object} style - Additional styles
 * @param {Object} rest - Additional RangePicker props
 */
function DateRangePicker({
  value,
  onChange,
  presets = rangePresets,
  format = 'YYYY-MM-DD',
  showTime = false,
  placeholder = ['Start Date', 'End Date'],
  style = {},
  ...rest
}) {
  return (
    <RangePicker
      value={value}
      onChange={onChange}
      presets={presets}
      format={format}
      showTime={showTime}
      placeholder={placeholder}
      style={{ width: 300, ...style }}
      {...rest}
    />
  );
}

export default DateRangePicker;
export { rangePresets };
